import { createContext } from './create-context.js';

const [RenderStrategyPropsProvider, useRenderStrategyProps] = createContext("RenderStrategyProps");

export { RenderStrategyPropsProvider, useRenderStrategyProps };
